<template>
  <div class="container-van-truck-main">
    <div class="container-van-truck" >
      <div class="container-van-truck_cards">
        <div class="container-van-truck_cards-title">
          <p>
           We are also providing FCL domestic transportation (by sea or by road) together with the tally services and door-to-door delivery.
          </p>
          <p>
           
With our wide range of container trucks and small trucks combined with major domestic feeder operators, WR1 can provide the domestic distribution to any areas in Vietnam.
          </p>
          <div class="container-van-truck_cards-title-meta">
            <img
              class="container-van-truck_cards-title-meta-photo"
              v-lazy="
                require(`@/assets/images/core-service/container&-van-truck-1.png`)
              "
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="container-van-truck-text">
      <div class="container-van-truck-text-blog-card">
        <div class="container-van-truck-text-blog-card-text">
          <div>
            <p class="container-van-truck-text-blog-card-text-description">
             Dịch vụ Trucking của WR1 bao gồm cả dịch vụ Container và Xe tải các loại.<br/>
             Với giải pháp tiên tiến, hiện đại, WR1 là một trong những đơn vị tiên phong trong việc áp dụng công nghệ kỹ thuật vào quy trình quản lý vận tải.
             <br/>Cùng với đội ngũ tài xế chuyên nghiệp, chúng tôi tự tin mang tới dịch vụ có chất lượng cao nhất, làm hài lòng những khách hàng khó tính nhất.
            </p>
            <p class="container-van-truck-text-blog-card-text-description">
              WR1 mang tới cho bạn rất nhiều những lợi ích:
              <ul>
                <li>
                Mạng lưới vận tải lớn ở hai thị trường Bắc và Nam; 
                </li>
                  <li>
           Đội ngũ tài xế với tác phong chuyên nghiệp, an toàn;
                </li>
                  <li>
               Đội ngũ điều hành nhiều kinh nghiệm, nhiệt huyết;
                </li>
                  <li>
             Quy trình chặt chẽ, liên tục cập nhật thông tin kịp thời;
                </li>
                  <li>
               Liên hệ, book xe tiện lợi, nhanh chóng;
                </li>
                  <li>
             Theo dõi, quản lý lộ trình hàng hóa bằng công nghệ mới;
                </li>
                  <li>                
                Các giải pháp tối ưu cắt giảm chi phí;
                </li>
                  <li>
            Các giá trị khác …
                </li>
               

                </ul>
            </p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.container-van-truck-main {
  position: relative;

  @media (min-width: 1024px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 15%;
        transform: translate(0, -50%);
        right: -80px;
        background-image: url("../../../../../assets/images/core-service/core-top.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 800px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.png");
        background-size: 300px 300px;
        display: inline-block;
        width: 300px;
        height: 300px;
      }
    }
  }

  .container-van-truck {
    @media (min-width: 900px) {
      padding: 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    &_cards {
      padding: 40px;

      @media (min-width: 900px) {
        padding-left: 0;
      }
      &-title {
        color: var(--text-normal-color);
        font-style: var(--normal-font-size);
        font-weight: 400;
        &-meta {
          &-photo {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }

  .container-van-truck-text {
    @media (min-width: 900px) {
      padding: 40px 70px 70px;
    }
    @media (min-width: 1024px) {
      padding: 40px 70px 230px;
    }
    @media (min-width: 1900px) {
      padding: 100px 470px;
    }
    background-color: var(--bg-color-2);

    &-blog-card {
      &-text {
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
          ul {
            li {
              list-style: none !important;
              &::before {
                content: "\2022";
                color: #2b938c;
                font-weight: bold;
                display: inline-block;
                font-size: 20px;
                width: 1em;
                margin-left: -1.5em;
                margin-right: -10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>